import { Button, Icon } from 'bold-ui'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { useFlags } from 'config/useFlagsContext'
import { TopicoNotificacaoDocument, useMarcarRegulacaoComoLidaMutation } from 'graphql/hooks.generated'
import React, { useState } from 'react'

import { ListaRegulacaoModal } from '../modal/ListaRegulacaoModal'
import { ListaRegulacaoTableItem } from '../model-regulacao'

interface ListaRegulacaoTableActionProps {
  item: ListaRegulacaoTableItem
}

export const ListaRegulacaoTableAction = (props: Readonly<ListaRegulacaoTableActionProps>) => {
  const { item } = props
  const [modalOpen, setModalOpen] = useState(false)
  const { PILOTO_NOTIFICACAO_LOTACAO_ENABLED } = useFlags()
  const topicoId = item.topicoNotificacao?.id

  const [marcarRegulacaoComoLida] = useMarcarRegulacaoComoLidaMutation()

  const handleModalOpen = () => {
    setModalOpen(true)
    marcarRegulacaoComoLida({
      variables: {
        id: item.id,
      },
      refetchQueries: [
        PILOTO_NOTIFICACAO_LOTACAO_ENABLED &&
          topicoId && {
            query: TopicoNotificacaoDocument,
            variables: { id: topicoId },
          },
      ].filter(Boolean),
      awaitRefetchQueries: true,
    })
  }

  const notificar = item.topicoNotificacao?.statusNotificarLido

  return (
    <>
      <Button onClick={handleModalOpen} skin='ghost' size='small'>
        <BadgeNotificacao value={notificar} type='small' color='blue'>
          <Icon icon='zoomOutline' />
        </BadgeNotificacao>
      </Button>

      {modalOpen && <ListaRegulacaoModal item={item} handleClose={() => setModalOpen(false)} />}
    </>
  )
}
